<template>

  <div>
    <div v-if="brand && category_name !== 'Зарядные устройства'" class="faqBlock">
      <div class="fetchBrend" @click="fetchProductBrand(brand)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="15px" height="15px" viewBox="-64 0 512 512">
        <path d="M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"/>
        </svg>
      </div>

        <div class="faqProducts" v-if="isVisibleHelper">
        <div class="titl">
           <div>Бренд <span><b>{{ brand }}</b></span></div>
           <div class="closed" @click="closedFunc"><svg data-v-193e795c="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="omnica-popper-target" style="width: 100%;"><path data-v-193e795c="" d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg></div>
          </div>
        <br />

        <div v-if="plusi">
            <span class="plusi"><b>Плюсы </b> <svg xmlns="http://www.w3.org/2000/svg" width="13px" height="13px" viewBox="0 0 24 24" fill="none">
<path d="M4 12H20M12 4V20" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span>
            <p v-html="plusi"></p>
        </div>
        <br />

        <div v-if="minusi">
            <span class="minusi"><b>Минусы</b> <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="13px" height="13px" viewBox="0 0 24 24" id="minus" class="icon glyph"><path d="M19,13H5a1,1,0,0,1,0-2H19a1,1,0,0,1,0,2Z"/></svg></span>
            <p v-html="minusi"></p>
        </div>
        
        </div>
    </div>

  </div>

</template>

<script>import { ORDERS_API_BASE } from '@/config/api';


import axios from 'axios';

export default {
  name: "Helper",
  data(){
    return {
      isVisibleHelper: false,
      plusi: '',
      minusi: ''
    }
  },
  props: {
    product: {
      type: String,
      required: true
    },
    brand: {
      type: String,
      required:false
    },
    category_name: {
      type: String,
      required: false
    }
  },
  methods: {
    async fetchProductBrand(brend) {
      try {
        const response = await axios.get(`${ORDERS_API_BASE}/highload_helper.php?brand=${brend}`);
        if(response){
          const data = response.data[0];
          this.plusi = data.UF_PLUSI || '';
          this.minusi = data.UF_MINUSI || '';
          this.isVisibleHelper = !this.isVisibleHelper;
        }
      } catch (error) {
        console.error(`Не удалось загрузить бренд ${brend}:`, error);
        this.plusi = '';
        this.minusi = '';
      }
    },
    closedFunc(){
      this.isVisibleHelper = !this.isVisibleHelper;
    },
  }
};
</script>

<style scoped>
.faqBlock {
    margin-right: 0;
    cursor: pointer;
    position: relative;
}

.faqProducts {
    transition: 0.3s;
    z-index: 9999;
    position: absolute;
    font-size: 12px;
    font-weight: 400;
    margin-top: 5px;
    width: 600px;
    text-align: left;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    background-color: #fff; /* если фон не белый */
    padding: 20px;
    transition: box-shadow 0.3s ease;
}

.titl {
  font-size: 20px;
  display: flex;
}

.fetchBrend {    
  padding: 15px 5px;
    transition: 0.3s;
    text-align: center;
}
.fetchBrend:hover {
    background: #f4f6f8;
}

.titl .closed {
  margin-left: auto;
}
.titl .closed svg {
  width: 24px;
  height: 24px;
  transition: 0.3s;
}

.titl .closed:hover svg {
  transform: rotate(180deg);
}

.faqProducts .plusi,
.faqProducts .minusi {
    font-size: 14px;
    margin-bottom: 5px;
    display: block;
}
.faqProducts .plusi{
  color: rgb(25, 184, 25);
}
.faqProducts .minusi {
  color: rgb(222, 45, 45);
}
</style>